export default function prettifyNumber(num: number, fractionalDigit: number = 2) {
  return num.toFixed(fractionalDigit);
}
